// NOTE: Please format dates like YYYY-MM-DD
export const sosVideos = [
    {
        name: 'Flow | SOS 2017',
        date: "2017-06-17",
        videoLink: "https://www.youtube.com/embed/NW8-z9STpsk",
    },
    {
        name: 'Flow | SOS 2016',
        date: "2016-06-12",
        videoLink: "https://www.youtube.com/embed/Pc8mqPh6ETM",
    },
    {
        name: 'Flip Flop | SOS 2018',
        date: "2018-06-09",
        videoLink: "https://www.youtube.com/embed/PU3K9p09oEE",
    },
    {
        name: '"Onwards" | StuyFlow x Virtual SOS 2020',
        date: "2020-06-27",
        videoLink: "https://www.youtube.com/embed/QZ8nKRLsdyA",
    },
    {
        name: 'Flow | SOS 2019',
        date: "2019-06-10",
        videoLink: "https://www.youtube.com/embed/xLej9FH0PQw?start=1",
    },
]
